module.exports = __webpack_public_path__ + "7ae52a6d0c41f4ac79a5ecb9f5348000.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/SpatialGuardOFF.mp4
// module id = 398
// module chunks = 0